// import * as engine from '../engine/engine';
import {springboard} from '../engine/register';

// export const Springboard = engine.Springboard;
// export const SpringboardProvider = engine.SpringboardProvider;

export default springboard;
